<script setup>
import LogoModal from '@/components/modal/LogoModal.vue';
import DetailsModal from './DetailsModal.vue';

const props = defineProps({
  session: Object,
  eventId: String,
});

const emit = defineEmits(['close', 'refresh']);

const close = () => emit('close');
</script>
<template>
  <logo-modal @close="close">
    <template v-slot:body>
      <details-modal
        @form-submitted="emit('refresh')"
        :data="props.session"
        :eventId="props.eventId"
      >
      </details-modal>
    </template>
  </logo-modal>
</template>
